import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import ContentCheckPolicyManager from './ContentCheckPolicyManager';

/**
 * ContentCheckPolicyManagerDialog Component
 *
 * Wraps ContentCheckPolicyManager in a dialog for use in template editor.
 */
const ContentCheckPolicyManagerDialog = ({ open, onClose, templateId }) => {
  if (!templateId) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogContent sx={{ p: 0, position: 'relative' }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 1,
            bgcolor: 'background.paper',
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ height: '100%', overflow: 'auto' }}>
          <ContentCheckPolicyManager templateId={templateId} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContentCheckPolicyManagerDialog;
